import { map } from 'lodash';
import { z } from 'zod';

import {
  type Activity,
  ActivitySchema,
} from '@/modules/documents/domain/entities/activity';
import type { IActivityRepository } from '@/modules/documents/domain/repositories/activity.repository';

import { type BodyOf, FeApi } from '../fetch-client';

import { activityMapper } from './entities/activity.mapper';

export namespace ActivityRepositoryMapper {
  export namespace getAll {
    export const outputSchema = z.array(ActivitySchema);

    export function outputFromData(
      data: FeApi.ListActivitiesViewOutput,
    ): Promise<Activity[]> {
      return outputSchema.parseAsync(map(data.activities, activityMapper));
    }

    export function bodyFromInput(
      input: IActivityRepository.GetAllInput,
    ): BodyOf<typeof FeApi.recordsV1ActivitiesListRetrieve> {
      return {
        siteAccureId: input.siteId,
        dateThreshold: input.after?.toISOString(),
        activityCategory: input.fileActions,
        documentType: input.documentType,
      };
    }
  }
}
